<template>
	<div class="main">
		<!-- {{qaedaData}}<br /> -->
		<!-- {{devicesData}}<br /> -->
		<!-- {{lineDevicesData}}<br /> -->
		<!-- {{TDVData}}<br /> -->
		<div class="data-card-black1">
			<div class="card-black-title">
				<b>最新数据</b>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/data.png" alt="">
				</div>
				<div class="content-data">
					{{ devicesData.devicesDataName + devicesData.devicesDataNum }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/camera.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.videoName + TDVData.videoCount }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/device.png" alt="">
				</div>
				<div class="content-data">
					{{ lineDevicesData.onLineDevicesName + lineDevicesData.onLineDevicesNum }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/sensor.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.devicesName + TDVData.devicesCount }}
				</div>
			</div>
			<div class="card-black-content card-black-bottom">
				<div class="content-img">
					<img src="./../assets/hadoop/terminal.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.terminalName + TDVData.terminalCount }}
				</div>
			</div>
		</div>
		<div class="data-card-black2">
			<div class="card-black-title">
				<b>系统数据</b>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/lot.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.lotSystemName + TDVData.lotSystemCount }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/irrigation.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.irrigationSystemName + TDVData.irrigationSystemCount }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/alarm.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.alarmSystemName + TDVData.alarmSystemCount }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/trace.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.traceSystemName + TDVData.traceSystemCount }}
				</div>
			</div>
			<div class="card-black-content">
				<div class="content-img">
					<img src="./../assets/hadoop/production.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.productionSystemName + TDVData.productionSystemCount }}
				</div>
			</div>
			<div class="card-black-content card-black-bottom">
				<div class="content-img">
					<img src="./../assets/hadoop/abilityNum.png" alt="">
				</div>
				<div class="content-data">
					{{ TDVData.abilityNumSystemName + TDVData.abilityNumSystemCount }}
				</div>
			</div>
		</div>
		<!-- <div class="data-card1">
			{{TDVData}}
		</div> -->
		<!-- <div class="data-bottom">
			<div class="data-card" style="background-color: red;">
				<div class="data-card-content">{{ TDVData.productionSystemCount }}</div>
				<div class="data-card-title">{{ TDVData.productionSystemName }}生产管理系统数</div>
			</div>
			<div class="data-card" style="background-color: blue;">
				<div class="data-card-content">{{ TDVData.traceSystemCount }}</div>
				<div class="data-card-title">{{ TDVData.productionSystemName }}溯源系统数</div>
			</div>
			<div class="data-card" style="background-color: grey;">
				<div class="data-card-content">{{ TDVData.irrigationSystemCount }}</div>
				<div class="data-card-title">{{ TDVData.productionSystemName }}灌溉系统数</div>
			</div>
			<div class="data-card" style="background-color: green;">
				<div class="data-card-content">{{ TDVData.alarmSystemCount }}</div>
				<div class="data-card-title">{{ TDVData.productionSystemName }}预警系统数</div>
			</div>
			<div class="data-card" style="background-color: gray;">
				<div class="data-card-content">{{ TDVData.abilityNumSystemCount }}</div>
				<div class="data-card-title">{{ TDVData.productionSystemName }}智能盘数系统数</div>
			</div>
		</div> -->
		<div id="myMap" class="myMapClass" ref="myMap" :style="'height: '+$store.state.height+'px;'"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				qaedaData: [],
				devicesData: [],
				lineDevicesData: [],
				TDVData: [],
				mapScale: [
					20,
					50,
					100,
					200,
					500,
					1000,
					2000,
					5000,
					10000,
					20000,
					25000,
					50000,
					100000,
					200000,
					500000,
					1000000,
					2000000,
					5000000,
					10000000
				]
			}
		},
		methods: {
			load()
			{
				this.getDevices();
				this.getLineDevices();
				this.getQaeda();
				this.getTDV();
			},
			getQaeda()
			{
				this.api.Statistics.getList()
				.then((res)=>{
					if(res.data.code==1)
					{
						let data=[];
						res.data.data.list.map((value)=>{
							if(value.token)
							{
								data.push(value);
							}
						});
						this.qaedaData=data;
						this.initMap();
					}
				})
			},
			getDevices()
			{
				this.api.Statistics.devicesData()
				.then((res)=>{
					if(res.data.code==1)
					{
						this.devicesData=res.data.data;
					}
				})
			},
			getLineDevices()
			{
				this.api.Statistics.onLineDevices()
				.then((res)=>{
					if(res.data.code==1)
					{
						this.lineDevicesData=res.data.data;
					}
				})
			},
			getTDV()
			{
				this.api.Statistics.terminalDevicesVideo()
				.then((res)=>{
					if(res.data.code==1)
					{
						this.TDVData=res.data.data;
					}
				})
			},
			initMap () {
				this.createMap() ; //创建地图
				this.setMapEvent();//设置地图事件
				this.addMapControl();//向地图添加控件
				this.addMarker();//向地图中添加marker
			},
			createMap(){
				var map = new BMap.Map(this.$refs.myMap);//在百度地图容器中创建一个地图
				var maxWayData = this.getMaxWay();
				var size = 1;
				for(var i=0;i<this.mapScale.length;i++)
				{
					var a =maxWayData.maxWay/this.mapScale[i];
					if(a<9)
					{
						size=19-i;
						break;
					}
				}
				if(!maxWayData.maxWay)
				{
					size=15;
				}
				map.centerAndZoom(this.getPoint(),size);//设定地图的中心点和坐标并将地图显示在地图容器中
				window.map = map;//将map变量存储在全局
			},
			getMaxWay()
			{
				var maxX=0,maxY=0,minX=0,minY=0;
				var map = new BMap.Map();
				if(this.qaedaData.length>0)
				{
					maxY=maxX=minX=minY=new BMap.Point(this.qaedaData[0].latlong.split(",")[1],this.qaedaData[0].latlong.split(",")[0]);
				}
				else
				{
					return{
						maxWay: 25000,
						maxdian: new BMap.Point(103.97384238677978,30.734417850955477),
						mindian: new BMap.Point(103.97384238677978,30.734417850955477)
					};
				}
				for(var i=1;i<this.qaedaData.length;i++)
				{
					if(Number(this.qaedaData[i].latlong.split(",")[1])>maxX.lng)
					{
						maxX=new BMap.Point(this.qaedaData[i].latlong.split(",")[1],this.qaedaData[i].latlong.split(",")[0]);
					}
					if(Number(this.qaedaData[i].latlong.split(",")[0])>maxY.lat)
					{
						maxY=new BMap.Point(this.qaedaData[i].latlong.split(",")[1],this.qaedaData[i].latlong.split(",")[0]);
					}
					if(Number(this.qaedaData[i].latlong.split(",")[1])<minX.lng)
					{
						minX=new BMap.Point(this.qaedaData[i].latlong.split(",")[1],this.qaedaData[i].latlong.split(",")[0]);
					}
					if(Number(this.qaedaData[i].latlong.split(",")[0])<minY.lat)
					{
						minY=new BMap.Point(this.qaedaData[i].latlong.split(",")[1],this.qaedaData[i].latlong.split(",")[0]);
					}
				}
				var maxdian=maxX;
				var mindian=minX;
				var maxWay=Number((map.getDistance(maxX,minX)).toFixed(2));
				if(Number((map.getDistance(maxX,maxY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(maxX,maxY)).toFixed(2));
					maxdian=maxX;
					mindian=maxY;
				}
				if(Number((map.getDistance(maxX,minY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(maxX,minY)).toFixed(2));
					maxdian=maxX;
					mindian=minY;
				}
				if(Number((map.getDistance(minX,maxY)).toFixed(2))>maxWay)
				{
					console.log(1);
					maxWay=Number((map.getDistance(minX,maxY)).toFixed(2));
					maxdian=minX;
					mindian=maxY;
				}
				if(Number((map.getDistance(minX,minY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(minX,minY)).toFixed(2));
					maxdian=minX;
					mindian=minY;
				}
				if(Number((map.getDistance(maxY,minY)).toFixed(2))>maxWay)
				{
					maxWay=Number((map.getDistance(maxY,minY)).toFixed(2));
					maxdian=maxY;
					mindian=minY;
				}
				return {
					maxWay: maxWay,
					maxdian: maxdian,
					mindian: mindian
				};
			},
			getPoint()
			{
				var dian=this.getMaxWay();
				return new BMap.Point((dian.maxdian.lng+dian.mindian.lng)/2,(dian.maxdian.lat+dian.mindian.lat)/2);
			},
			setMapEvent(){
				map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
				map.enableScrollWheelZoom();//启用地图滚轮放大缩小
				map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
				map.enableKeyboard();//启用键盘上下左右键移动地图
			},
			addMapControl(){
				//向地图中添加缩放控件
				var ctrl_nav = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
				map.addControl(ctrl_nav);
				//向地图中添加缩略图控件
				var ctrl_ove = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:1});
				map.addControl(ctrl_ove);
				//向地图中添加比例尺控件
				var ctrl_sca = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
				map.addControl(ctrl_sca);
			},
			addMarker(){
				var markerArr =this.qaedaData;
				var point = new Array();//定义数组标注经纬信息
				var marker = new Array();//定义数组点对象信息
				var info = new Array();//定义悬浮提示信息
				for(let i = 0; i < markerArr.length; i++){//遍历
					var infoA = markerArr[i].latlong.split(",")[1];//分割|
					var infoB = markerArr[i].latlong.split(",")[0];
					point[i] = new window.BMap.Point(infoA,infoB);
					marker[i] = new window.BMap.Marker(point[i]);
					map.addOverlay(marker[i]);
					//marker[i].setAnimation(BMAP_ANIMATION_BOUNCE);
					var label = new window.BMap.Label(markerArr[i].name,{offset: new window.BMap.Size(20,-10)});
					marker[i].setLabel(label);
					marker[i].addEventListener("click",()=>{
						console.log(markerArr[i]);
						this.setCookie(this.config.token,markerArr[i].token,3);
						this.setCookie(this.config.jdid,markerArr[i].id,3);
						let routes = this.$router.resolve({ path: '/iot/terminal' });
						window.open(routes.href, '_blank');
					});
				}
			}
		},
		watch:{
			
		},
		mounted() {
			this.load();
		},
		beforeDestroy() {
			
		}
	}
</script>

<style scoped>
	.main{
		position: relative;
	}
	.data-card1{
		position: absolute;
		top: 200px;
		right: 400px;
		width: 200px;
		background-color: rgba(65,105,225,0.5);
		color: white;
		text-align: center;
		z-index: 999;
	}
	.data-card-black1{
		position: absolute;
		top: 10px;
		right: 10px;
		width: 300px;
		background-color: rgba(0,0,0,0.5);
		color: white;
		z-index: 999;
	}
	.data-card-black2{
		position: absolute;
		top: 350px;
		right: 10px;
		width: 300px;
		background-color: rgba(0,0,0,0.5);
		color: white;
		z-index: 999;
	}
	.card-black-title{
		background-color: rgba(0,0,0,0.2);
		padding: 10px;
		font-size: 18px;
	}
	.card-black-content{
		display: flex;
		border-bottom: 1px dotted #fff;
	}
	.card-black-bottom{
		border-bottom: none;
	}
	.content-img{
		width: 40px;
		height: 40px;
		padding: 5px;
	}
	.content-img img{
		width: 40px;
		height: 40px;
	}
	.content-data{
		width: auto;
		height: 50px;
		line-height: 50px;
	}
	.data-bottom{
		position: absolute;
		width: 80%;
		bottom: 20px;
		left: 50%;
		margin-left: -40%;
		display: flex;
		justify-content: space-around;
		z-index: 999;
	}
	.data-card{
		width: 200px;
		height: 160px;
		border-radius: 10px;
		color: white;
		text-align: center;
	}
	.data-card-content{
		font-size: 50px;
		margin-top: 35px;
	}
	.data-card-title{
		font-size: 12px;
		margin-top: 15px;
	}
	.myMapClass{
		width: 100%;
	}
</style>
